<template>
  <div class="ContactUsForm">
    <h1 class="ContactUsLabel heading-1" v-html="contactUsTitle" />
    <div class="ContactUsMessage" v-html="contactUsMessage" />
    <Form @submit="Submit" class="ContactUsForm__form">
      <div class="InputWrapper">
        <Field type="text" name="name" :rules="validateName" v-model="form.name" class="Input"
          :placeholder="constants.name" minlength="2" />
        <ErrorMessage name="name" class="ErrorMessage" />
      </div>
      <div class="InputWrapper">
        <Field type="email" name="email" :rules="validateEmail" v-model="form.email" class="Input"
          :placeholder="constants.email" minlength="2" />
        <ErrorMessage name="email" class="ErrorMessage" />
      </div>
      <div class="InputWrapper contact-input-50">
        <Field name="category" as="select" :rules="validateCategory" v-model="form.category" class="Input">
          <option value="" selected>{{ constants.category }}</option>
          <option :value="category.Value" v-for="category in categories" :key="category.Value">{{ category.Name }}
          </option>
        </Field>
        <ErrorMessage name="category" class="ErrorMessage" />
      </div>
      <div class="InputWrapper contact-input-50">
        <Field type="text" name="subject" :rules="validateSubject" v-model="form.subject" class="Input"
          :placeholder="constants.subject" minlength="2" />
        <ErrorMessage name="subject" class="ErrorMessage" />
      </div>
      <div class="InputWrapper">
        <Field name="message" as="textarea" :rules="validateMessage" v-model="form.message" class="InputMessage"
          :placeholder="constants.message" minlength="2" />
        <ErrorMessage name="message" class="ErrorMessage" />
      </div>
      <div class="InputWrapper">
        <VueRecaptcha :sitekey="recaptchaKey" @verify="handleSuccess" @error="handleError"></VueRecaptcha>
        <span v-html="recaptchaErrorMessage" class="ErrorMessage"></span>
      </div>
      <button class="btn SubmitBtn" type="submit">{{ constants.submit }}</button>
      <div class="contact_message">
        <span v-html="error" v-if="error" class="Errors"></span>
        <span v-html="successMessage" class="SuccessMessage"></span>
      </div>
    </Form>
  </div>

</template>
<script>
import { Field, Form, ErrorMessage } from 'vee-validate';
import { VueRecaptcha } from 'vue-recaptcha';
import categoriesData from '@/assets/data/category.json'
import { CONTACTUS_CONSTANTS } from '@/constants/contactUsConstants';


export default {
  components: {
    Field,
    Form,
    ErrorMessage,
    VueRecaptcha
  },
  data() {
    return {
      constants: CONTACTUS_CONSTANTS,
      categories: categoriesData,
      recaptchaKey: '',
      contactUsMessage: '',
      contactUsTitle: 'Contactez-Nous',
      recaptchaVerified: false,
      recaptchaErrorMessage: null,
      recaptcha: null,
      success: false,
      error: null,
      successMessage: null,
      form: {
        name: null,
        email: null,
        subject: null,
        message: null,
        category: null
      }
    }
  },
  created() {
    this.recaptchaKey = process.env.VUE_APP_RECAPTCHA_KEY;
  },
  mounted() {
    if (this.contactUsMessage === '') {
      this.$api.getContactDetails().then(resp => {
        this.contactUsMessage = resp.data.data.form.body
        this.contactUsTitle = resp.data.data.form.title
      })
    }
  },
  methods: {
    back() {
      this.error = null
      this.success = false
    },
    Submit() {
      if (!this.recaptchaVerified) {
        this.recaptchaErrorMessage = this.constants.required;
        return;
      }

      this.recaptchaErrorMessage = null
      this.error = null
      let data = this.form

      data['g-recaptcha-response'] = this.recaptcha;
      this.$api.postContactMessages(data)
        .then((resp) => {
          let e = resp.data
          if (e && e.Error) {
            let errors = []
            Object.entries(e.Error).map(entry => errors.push(entry[1].join('<br>')))
            this.error = errors.join('<br>')
          } else {
            if (e.code) {
              let code = e.code
              switch (code) {
                case "200":
                  this.successMessage = this.constants.successMessage;
                  this.success = true;
                  break;
                default:
                  this.error = this.constants.Error;
              }
            }
          }
        })
        .catch(e => {
          console.log('api error', e)
          this.error = this.constants.serverError;
        })

      return false;

    },
    validateName(value) {
      if (!value) {
        return this.constants.required;
      }
      return true;
    },
    validateEmail(value) {
      if (!value) {
        return this.constants.required;
      }

      const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

      if (!regex.test(value)) {
        return this.constants.emailMessageError;
      }

      return true;
    },
    validateCategory(value) {
      if (!value) {
        return this.constants.required;
      }
      return true;
    },
    validateSubject(value) {
      if (!value) {
        return this.constants.required;
      }
      return true;
    },
    validateMessage(value) {
      if (!value) {
        return this.constants.required;
      }
      return true;
    },
    handleError() {
      this.recaptchaVerified = false;
      this.recaptcha = null
    },
    handleSuccess(response) {
      this.recaptchaVerified = true;
      this.recaptcha = response;
      this.recaptchaErrorMessage = null
    },
  }
}
</script>

<style lang="scss">
  @import "../../scss/contact";
  @import "@/scss/helpers/mixins";
  @import "@/scss/helpers/variables";

  .ContactUsForm {
    width: 100%;
    padding: 0 15px 45px;

    @include min($lg) {
      max-width: 341px;
    }

      &__form {
        margin: 25px -5px 0;
        display: flex;
        flex-wrap: wrap;
      }
  }

  .SuccessMessage {
    margin-bottom: 15px;
    margin-top: 10px;
  }

  .SubmitBtn {
    width: 100%;

    @include min($lg) {
      width: auto;
    }
  }

  .ContactUsLabel,
  .title {
    text-align: left;
    letter-spacing: -0.7px;
    color: #283861;
    @media screen and (max-width: 768px) {
      font-size: 22px;
    }
  }

  .ContactUsMessage {
    color: var(--unnamed-color-283861);
    text-align: left;
    font: normal normal normal 16px/22px Lato;
    letter-spacing: 0px;
    color: #283861;
    margin-bottom: 10px;
  }

/*
  .Input,
  .InputMessage {
    margin-bottom: 0;
    background: #eee 0% 0% no-repeat padding-box;
    box-shadow: inset 0px 3px 3px rgba(40, 56, 97, 0.102);
    border-radius: 25px;
    padding: 0 10px;
    display: block;
    color: #283861;
    font-size: 14px;
    font-weight: 700;
    width: -webkit-fill-available;
    min-height: 40px;
    border: none;

    &:focus-visible,
    &:focus,
    &:focus-within {
      outline: none;
      box-shadow: 0;
    }
  }
*/
  // .InputMessage {
  //   padding: 10px;
  // }

  .InputWrapper {
    padding-left: 5px;
    padding-right: 5px;
    margin-bottom: 15px;
    width: 100%;
    flex: 0 0 100%;

    .mention {
      font-size: 11px;
      display: block;
    }

    .ErrorMessage {
      font-size: 13px;
      color: red;
      display: block;
    }
  }
  select {
    &.Input {
      @include min($lg) {
        max-width: 134px;
      }
    }
  }

  .contact-input-50 {
    width: 50%;
    flex: 0 0 50%;

    @include min($lg) {
      width: 100%;
      flex: 0 0 100%;
    }
  }

  .contact_message {
    width: 100%;
    flex: 0 0 100%;
    margin-top: 10px;
  }
</style>